const projectSettings = {
  archivedBanner:
    "This project is archived, meaning it is read-only. Restore it under Project Controls to make changes.",
  loading: "Loading settings…",
  details: {
    title: "Project Details",
    description: "The project's name and description shown to all members.",
    titleLabel: "Title",
    saveButton: "Save Details",
    saving: "Saving…",
    saved: "Project details saved.",
  },
  settings: {
    title: "Project Settings",
    description:
      "Configure default behavior for data access and notifications in this project.",
    saveButton: "Save Settings",
    saving: "Saving…",
    saved: "Settings saved.",
  },
  researcherAccess: {
    title: "Default researcher access",
    description:
      "How datasets uploaded for this project are exposed to researchers.",
    piApproval: "Require data request (PI approval)",
    autoGrant: "Auto-grant to project members",
  },
  catalogVisibility: {
    title: "Default catalog visibility",
    description: "Who can discover datasets uploaded for this project.",
    projects: "This project",
    org: "Everyone in your organization",
    hidden: "Hidden",
  },
  autoNotify: {
    title: "Auto-notify on upload",
    description:
      "Automatically notify the requester and the project's PIs when data is uploaded.",
  },
  controls: {
    title: "Project Controls",
  },
  archive: {
    restoreTitle: "Restore project",
    restoreDescription:
      "Restore project to bring it back to the active projects list",
    archiveTitle: "Archive project",
    archiveDescription:
      "Retire this project: it disappears from the default project lists. Nothing is deleted and you can restore it at any time.",
    restoreButton: "Restore Project",
    restoring: "Restoring…",
    archiveButton: "Archive Project",
    confirmArchive: "Confirm Archive",
    archiving: "Archiving…",
  },
  leave: {
    title: "Leave project",
    description:
      "Remove yourself from this project. You'll lose access unless you're re-invited.",
    onlyPiDescription:
      "You are the only PI on this project. Assign another PI before you can leave.",
    onlyPiHint: "Assign another PI before leaving the project",
    leaveButton: "Leave Project",
    confirmLeave: "Confirm Leave",
    leaving: "Leaving…",
  },
  errors: {
    loadFailed: "Failed to load settings",
    titleRequired: "Title is required.",
    saveDetailsFailed: "Failed to save project details",
    saveSettingsFailed: "Failed to save settings",
  },
};

export default projectSettings;
